import { ActionType, AtButton } from '@curran-catalog/curran-atomic-library'

export const Default404Page = () => (
  <div className="h-screen tw-w-screen flex flex-col tw-gap-4 justify-center items-center">
    <span className="tw-text-secondary tw-text-xl tw-font-bold">404</span>
    <AtButton label="Return to Home" actionType={ActionType.OPEN_URL} actionValue="/" />
  </div>
)
